import { useEffect, useState } from 'react';
import { useApp } from '../../../contexts/AppContext';
import { sendVenueInquiry, getCountryMaster } from '../../../api';
import styled from 'styled-components';
import config from '../../../config';
import {
  PageMainTitle,
  SubInner,
  SectionTitle,
  InputLabel,
  FormTextArea,
  RequiredLabel,
  FormInput,
} from '../../atoms/CommonParts';
import DBDPullDown from '../../atoms/DBDPullDown';
import {
  useCustomDialog,
  ButtonLayout,
} from '../../../contexts/CustomDialogContext';
import { Link, useLocation } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useLang, withLang } from '../../../i18n/langPath';
import headerImagePC from './djm_head_pc.webp';
import headerImageSP from './djm_head_sp.webp';
import venue1 from './venue1.webp';
import venue2 from './venue2.webp';
import venue3 from './venue3.webp';
import tradeBody1 from './body1.webp';
import tradeBody2 from './body2.webp';
import tradeBody3 from './body3.webp';
import dj1 from './dj1.webp';
import dj2 from './dj2.webp';
import dj3 from './dj3.webp';
import dj4 from './dj4.webp';
import dj5 from './dj5.webp';
import dj6 from './dj6.webp';
import dj7 from './dj7.webp';
import dj8 from './dj8.webp';

import venuesBGPC from './venues_bg_pc.webp';
import venuesBGSP from './venues_bg_sp.webp';
import venueBanners from './venues.webp';
import clientsBGPC from './clients_bg_pc.webp';
import clientsBGSP from './clients_bg_sp.webp';
import clientsBanners from './clients.webp';

const Page = styled.div``;

const Inner = styled.div`
  margin-top: 47px;
  @media ${config.layout.wide} {
    margin-top: 84px;
    padding: 0 64px;
  }
`;

const ContentsSection = styled.section``;

const ContentsHeader = styled.div`
  height: 330px;
  position: relative;
  background-image: url('${headerImageSP}');
  background-size: cover;
  background-position: center;

  @media ${config.layout.wide} {
    height: 420px;
    background-image: url('${headerImagePC}');
  }
`;

const ContentsHeaderText = styled.div`
  position: absolute;
  left: 20px;
  text-align: center;
  font-size: 48px;
  line-height: 48px;
  font-weight: 300;
  color: #fff;
  bottom: 20px;

  @media ${config.layout.wide} {
    font-size: 96px;
    line-height: 96px;
    text-align: left;
    left: 50px;
    bottom: 72px;
    top: unset;
  }
`;

const MessageSection = styled.section`
  background-color: #f8f8f8;
  padding-bottom: 20px;

  padding-top: 20px;
  @media ${config.layout.topwide} {
    padding-top: 0px;
    padding-bottom: 50px;
  }

  h3 {
    padding: 70px 20px 32px;
    font-size: 32px;
    font-weight: bold;
    line-height: 43px;
    @media ${config.layout.topwide} {
      padding: 88px 50px 50px;
    }
  }
`;

const MessageSubSections = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 50px;
  &:nth-child(2) {
    margin-top: 0;
  }

  @media ${config.layout.topwide} {
    flex-direction: row;
    margin-top: 100px;
    align-items: center;

    img {
      border-radius: 0px 8px 8px 0px;
    }

    &:nth-child(2) {
      margin-top: 0;
    }

    &:nth-child(2n + 1) {
      flex-direction: row-reverse;
      img {
        border-radius: 8px 0px 0px 8px;
      }
    }
  }
`;

const MessageSubSection = styled.div`
  @media ${config.layout.topwide} {
    width: 50%;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    padding: 0 20px;
    margin-bottom: 1em;
    color: #4a4a4a;
    @media ${config.layout.topwide} {
      padding: 0 50px;
    }

    &.venue-name {
      font-weight: bold;
      font-size: 24px;
      line-height: 24px;
    }
    &.venue-testimonial {
      font-weight: normal;
      font-size: 18px;
      line-height: 28px;
      color: #4a4a4a;
    }
    &.venue-author {
      font-weight: bold;
      font-size: 16px;
      line-height: 28px;
      color: #000;
    }
  }

  img {
    width: 100%;
    height: auto;
    display: inline-block;
    margin-bottom: 37px;

    @media ${config.layout.topwide} {
      width: 100%;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`;

const HowUseSection = styled.section`
  background-color: #f8f8f8;
  padding: 70px 20px;

  @media ${config.layout.topwide} {
    padding: 88px 50px;
  }

  h3 {
    font-size: 32px;
    font-weight: bold;
    line-height: 32px;
    @media ${config.layout.topwide} {
      font-size: 36px;
      line-height: 46px;
    }
  }
`;

const HowUserItems = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  gap: 50px;

  @media ${config.layout.topwide} {
    flex-direction: row;
    margin-top: 60px;
    align-items: center;
    gap: 32px;
  }
`;

const HowUseItem = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 26px;

  @media ${config.layout.topwide} {
    flex-direction: column;
    align-items: flex-start;
  }

  svg {
    width: 50px;
    flex: 0 0 auto;
  }

  p {
    margin: 0;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    color: #000;
  }
`;

const TradeBodiesSection = styled.section`
  background-color: #f8f8f8;
  padding: 70px 20px;

  @media ${config.layout.topwide} {
    padding: 88px 50px;
  }

  h3 {
    font-size: 32px;
    font-weight: bold;
    line-height: 32px;
    @media ${config.layout.topwide} {
      font-size: 36px;
      line-height: 46px;
    }
  }
`;

const TradeBodiesItems = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 36px;
  gap: 70px;

  @media ${config.layout.topwide} {
    flex-direction: row;
    margin-top: 50px;
    align-items: flex-start;
    gap: 70px;
  }
`;

const TradeBodiesItem = styled.div`
  @media ${config.layout.topwide} {
    flex: 1;
  }

  img {
    width: 150px;
    display: block;
    border-radius: 8px;

    @media ${config.layout.topwide} {
      width: 200px;
    }
  }

  p {
    margin-bottom: 0;
  }

  .trade-body-testimonial {
    margin-top: 30px;
    font-size: 18px;
    line-height: 28px;
    color: #4a4a4a;
  }
  .trade-body-author {
    margin-top: 28px;
    font-size: 16px;
    line-height: 18px;
    font-weight: bold;
    color: #000;
  }
  .trade-body-position {
    margin-top: 12px;
    font-size: 12px;
    line-height: 12px;
    color: #000;
  }
`;

const ArtistTestimonialSection = styled.section`
  background-color: #f8f8f8;
  padding: 70px 20px;
  border-bottom: 1px solid #d9d9d9;

  @media ${config.layout.topwide} {
    padding: 88px 50px;
  }

  h3 {
    font-size: 32px;
    font-weight: bold;
    line-height: 32px;
    @media ${config.layout.topwide} {
      font-size: 36px;
      line-height: 46px;
    }
  }
`;

const ArtistTestimonialItemsColumns = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 36px;
  gap: 30px;

  @media ${config.layout.topwide} {
    flex-direction: row;
    margin-top: 39px;
    align-items: flex-start;
    gap: 32px;
  }
`;

const ArtistTestimonialItems = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 36px;
  gap: 30px;
  align-items: flex-start;

  @media ${config.layout.topwide} {
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    gap: 36px;
  }
`;

const ArtistTestimonialItem = styled.div`
  @media ${config.layout.topwide} {
    flex: 1;
  }

  border-radius: 8px;
  background: #fff;
  border: 1px solid #d9d9d9;
  padding: 40px 32px;

  .artist-testimonial {
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
    text-align: left;
    color: #4a4a4a;
    margin-bottom: 0;
  }
`;

const ArtistTestimonialAuthorArea = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 16px;
  align-items: center;

  img {
    width: 60px;
    height: 60px;
    display: block;

    @media ${config.layout.topwide} {
    }
  }

  .artist {
    .artist-author {
      font-size: 16px;
      line-height: 16px;
      font-weight: bold;
      color: #000;
      margin-bottom: 0;
    }
    .artist-position {
      margin-top: 8px;
      font-size: 12px;
      line-height: 12px;
      color: #000;
      margin-bottom: 0;
    }
  }
`;

const BannerListSection = styled.section`
  height: 320px;
  width: 100%;
  position: relative;
  overflow: hidden;

  @media ${config.layout.topwide} {
    height: 400px;

    &:before {
      content: '';
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      width: 10%;
      height: 100%;
      background: linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    }
    &:after {
      content: '';
      position: absolute;
      z-index: 2;
      top: 0;
      right: 0;
      width: 10%;
      height: 100%;
      background: linear-gradient(to left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    }
  }

  h3 {
    text-align: center;
    position: relative;
    z-index: 2;
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
    color: #fff;
    top: 40px;

    @media ${config.layout.topwide} {
      top: 85px;
    }
  }
`;

const BannerListBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
`;

const BannerListImages = styled.div`
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  height: 200px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  @media ${config.layout.topwide} {
    top: 100px;
    height: 250px;
  }
`;

const BannerListImage = styled.img`
  @keyframes banners {
    to {
      transform: translateX(-100%);
    }
  }

  height: 100%;
  width: auto;
  display: block;
  animation: banners 40s linear infinite;

  &.client-banner {
    animation: banners 15s linear infinite;
  }
`;

function Contents() {
  const { t } = useTranslation();
  return (
    <ContentsSection>
      <ContentsHeader>
        <ContentsHeaderText>{t('partners.headerLine1')}</ContentsHeaderText>
      </ContentsHeader>

      <MessageSection data-hash={'message'}>
        <h3>{t('partners.venuePartnerTestimonial')}</h3>
        <MessageSubSections>
          <MessageSubSection>
            <img src={venue1} />
          </MessageSubSection>
          <MessageSubSection>
            <p className={'venue-name'}>{t('partners.venue1Name')}</p>
            <p className={'venue-testimonial'}>
              {t('partners.venue1Testimonial')}
            </p>
            <p className={'venue-author'}>{t('partners.venue1Author')}</p>
          </MessageSubSection>
        </MessageSubSections>
        <MessageSubSections>
          <MessageSubSection>
            <img src={venue2} />
          </MessageSubSection>
          <MessageSubSection>
            <p className={'venue-name'}>{t('partners.venue2Name')}</p>
            <p className={'venue-testimonial'}>
              {t('partners.venue2Testimonial')}
            </p>
            <p className={'venue-author'}>{t('partners.venue2Author')}</p>
          </MessageSubSection>
        </MessageSubSections>
        <MessageSubSections>
          <MessageSubSection>
            <img src={venue3} />
          </MessageSubSection>
          <MessageSubSection>
            <p className={'venue-name'}>{t('partners.venue3Name')}</p>
            <p className={'venue-testimonial'}>
              {t('partners.venue3Testimonial')}
            </p>
            <p className={'venue-author'}>{t('partners.venue3Author')}</p>
          </MessageSubSection>
        </MessageSubSections>
      </MessageSection>
      <HowUseSection>
        <h3>{t('partners.howUseTitle')}</h3>
        <HowUserItems>
          <HowUseItem>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="45"
              viewBox="0 0 50 45"
            >
              <path
                id="newsmode_50dp_000_FILL0_wght400_GRAD0_opsz48"
                d="M83.75-795a3.6,3.6,0,0,1-2.625-1.125A3.6,3.6,0,0,1,80-798.75v-37.5a3.6,3.6,0,0,1,1.125-2.625A3.6,3.6,0,0,1,83.75-840h42.5a3.6,3.6,0,0,1,2.625,1.125A3.6,3.6,0,0,1,130-836.25v37.5a3.6,3.6,0,0,1-1.125,2.625A3.6,3.6,0,0,1,126.25-795Zm0-3.75h42.5v-37.5H83.75Zm6.813-6.625h28.875v-3.75H90.563Zm0-10.375h9.688v-13.875H90.563Zm16.188,0h12.688v-3.75H106.75Zm0-10.125h12.688v-3.75H106.75Zm-23,27.125v0Z"
                transform="translate(-80 840)"
              />
            </svg>
            <p>{t('partners.howUseItem1')}</p>
          </HowUseItem>
          <HowUseItem>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="39.938"
              viewBox="0 0 50 39.938"
            >
              <path
                id="music_cast_50dp_000_FILL0_wght400_GRAD0_opsz48"
                d="M101.563-762.687a8.9,8.9,0,0,1-2.625-6.562,8.9,8.9,0,0,1,2.625-6.562,8.9,8.9,0,0,1,6.563-2.625,8.421,8.421,0,0,1,2.906.469,11.034,11.034,0,0,1,2.531,1.344V-800H130v6.875H117.313v23.875a8.9,8.9,0,0,1-2.625,6.563,8.9,8.9,0,0,1-6.562,2.625A8.9,8.9,0,0,1,101.563-762.687ZM80-769.25a29.324,29.324,0,0,1,2.125-11.281A26.974,26.974,0,0,1,88-789.437a26.577,26.577,0,0,1,8.906-5.844,29.54,29.54,0,0,1,11.219-2.094v3.75a25.785,25.785,0,0,0-9.781,1.813,23.007,23.007,0,0,0-7.719,5.063,23.008,23.008,0,0,0-5.062,7.719,25.785,25.785,0,0,0-1.812,9.781Zm7.5,0a22.273,22.273,0,0,1,1.531-8.375,19.265,19.265,0,0,1,4.25-6.531,18.952,18.952,0,0,1,6.5-4.219,22.439,22.439,0,0,1,8.344-1.5v3.75q-7.687,0-12.281,4.563T91.25-769.25Z"
                transform="translate(-80 800)"
              />
            </svg>
            <p>{t('partners.howUseItem2')}</p>
          </HowUseItem>
          <HowUseItem>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="50"
              viewBox="0 0 40 50"
            >
              <path
                id="policy_50dp_000_FILL0_wght400_GRAD0_opsz48"
                d="M180-830a24.544,24.544,0,0,1-14.375-10.156A29.643,29.643,0,0,1,160-857.625V-872.5l20-7.5,20,7.5v14.875a35.532,35.532,0,0,1-1.344,9.656,24.418,24.418,0,0,1-4.719,8.906l-8.75-8.375a13.388,13.388,0,0,1-2.51,1.125,8.477,8.477,0,0,1-2.678.438,9.032,9.032,0,0,1-6.594-2.687,8.913,8.913,0,0,1-2.719-6.594,9.015,9.015,0,0,1,2.719-6.625A8.979,8.979,0,0,1,180-864.5a8.979,8.979,0,0,1,6.594,2.719,9.052,9.052,0,0,1,2.719,6.656,9.516,9.516,0,0,1-.375,2.625,7.07,7.07,0,0,1-1.187,2.375l5.5,5.25a22.33,22.33,0,0,0,2.25-6.031,30.61,30.61,0,0,0,.75-6.719v-12.4L180-875.937l-16.25,5.908v12.4a25.5,25.5,0,0,0,4.531,14.781,22.544,22.544,0,0,0,11.731,8.969,18.671,18.671,0,0,0,4.394-2.062,23.464,23.464,0,0,0,4.094-3l2.625,2.688a30.922,30.922,0,0,1-5.219,3.781A21.671,21.671,0,0,1,180-830Zm3.938-21.219a5.3,5.3,0,0,0,1.625-3.937,5.378,5.378,0,0,0-1.637-3.969,5.39,5.39,0,0,0-3.937-1.625,5.348,5.348,0,0,0-3.925,1.625,5.4,5.4,0,0,0-1.625,3.969,5.276,5.276,0,0,0,1.637,3.938,5.445,5.445,0,0,0,3.938,1.594A5.4,5.4,0,0,0,183.938-851.219ZM179.938-855.25Z"
                transform="translate(-160 880)"
              />
            </svg>
            <p>{t('partners.howUseItem3')}</p>
          </HowUseItem>
          <HowUseItem>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="57.971"
              height="45"
              viewBox="0 0 57.971 45"
            >
              <path
                id="artist_50dp_000_FILL0_wght400_GRAD0_opsz48"
                d="M128.406-764.985h9.565v4.348h-6.014v17.029a7.447,7.447,0,0,1-2.1,5.507,7.447,7.447,0,0,1-5.507,2.1,7.447,7.447,0,0,1-5.507-2.1,7.447,7.447,0,0,1-2.1-5.507,7.447,7.447,0,0,1,2.1-5.507,7.447,7.447,0,0,1,5.507-2.1,8.163,8.163,0,0,1,2.246.29,5.724,5.724,0,0,1,1.812.87ZM80-736v-6.812a8.8,8.8,0,0,1,1.232-4.457,7.706,7.706,0,0,1,3.7-3.225,55.534,55.534,0,0,1,9.674-3.37,38.063,38.063,0,0,1,8.587-.978,38.548,38.548,0,0,1,6.558.543,38.619,38.619,0,0,1,6.558,1.775,13.549,13.549,0,0,0-1.522,1.63,10.889,10.889,0,0,0-1.159,1.848,30.621,30.621,0,0,0-4.928-1.087,40.05,40.05,0,0,0-5.507-.362,37.416,37.416,0,0,0-7.9.8,41.294,41.294,0,0,0-8.623,3.116,3.93,3.93,0,0,0-1.739,1.63,4.379,4.379,0,0,0-.58,2.138v2.464h28.261a10.18,10.18,0,0,0,.833,2.464A7.178,7.178,0,0,0,114.783-736Zm15.362-26.3a10.594,10.594,0,0,1-3.043-7.826,10.594,10.594,0,0,1,3.043-7.826A10.594,10.594,0,0,1,103.188-781a10.594,10.594,0,0,1,7.826,3.043,10.594,10.594,0,0,1,3.043,7.826,10.594,10.594,0,0,1-3.043,7.826,10.594,10.594,0,0,1-7.826,3.044A10.594,10.594,0,0,1,95.362-762.3Zm12.5-3.152a6.335,6.335,0,0,0,1.848-4.674,6.335,6.335,0,0,0-1.848-4.674,6.335,6.335,0,0,0-4.674-1.848,6.335,6.335,0,0,0-4.674,1.848,6.335,6.335,0,0,0-1.848,4.674,6.335,6.335,0,0,0,1.848,4.674,6.335,6.335,0,0,0,4.674,1.848A6.335,6.335,0,0,0,107.862-765.456ZM103.188-770.13ZM103.188-740.348Z"
                transform="translate(-80 781)"
              />
            </svg>
            <p>{t('partners.howUseItem4')}</p>
          </HowUseItem>
        </HowUserItems>
      </HowUseSection>

      <BannerListSection>
        <BannerListBackground
          className="pc"
          style={{ backgroundImage: `url(${venuesBGPC})` }}
        />
        <BannerListBackground
          className="sp"
          style={{ backgroundImage: `url(${venuesBGSP})` }}
        />
        <h3>{t('partners.venueList')}</h3>
        <BannerListImages>
          <BannerListImage src={venueBanners} />
          <BannerListImage src={venueBanners} />
          <BannerListImage src={venueBanners} />
          <BannerListImage src={venueBanners} />
        </BannerListImages>
      </BannerListSection>

      <TradeBodiesSection>
        <h3>{t('partners.tradeBodiesTitle')}</h3>
        <TradeBodiesItems>
          <TradeBodiesItem>
            <img src={tradeBody1} />
            <p className="trade-body-testimonial">
              {t('partners.tradeBody1Testimonial')}
            </p>
            <p className="trade-body-author">
              {t('partners.tradeBody1Author')}
            </p>
            <p className="trade-body-position">
              {t('partners.tradeBody1Position')}
            </p>
          </TradeBodiesItem>
          <TradeBodiesItem>
            <img src={tradeBody2} />
            <p className="trade-body-testimonial">
              {t('partners.tradeBody2Testimonial')}
            </p>
            <p className="trade-body-author">
              {t('partners.tradeBody2Author')}
            </p>
            <p className="trade-body-position">
              {t('partners.tradeBody2Position')}
            </p>
          </TradeBodiesItem>
          <TradeBodiesItem>
            <img src={tradeBody3} />
            <p className="trade-body-testimonial">
              {t('partners.tradeBody3Testimonial')}
            </p>
            <p className="trade-body-author">
              {t('partners.tradeBody3Author')}
            </p>
            <p className="trade-body-position">
              {t('partners.tradeBody3Position')}
            </p>
          </TradeBodiesItem>
        </TradeBodiesItems>
      </TradeBodiesSection>

      <BannerListSection>
        <BannerListBackground
          className="pc"
          style={{ backgroundImage: `url(${clientsBGPC})` }}
        />
        <BannerListBackground
          className="sp"
          style={{ backgroundImage: `url(${clientsBGSP})` }}
        />
        <h3>{t('partners.clientList')}</h3>
        <BannerListImages>
          <BannerListImage src={clientsBanners} className="client-banner" />
          <BannerListImage src={clientsBanners} className="client-banner" />
          <BannerListImage src={clientsBanners} className="client-banner" />
          <BannerListImage src={clientsBanners} className="client-banner" />
        </BannerListImages>
      </BannerListSection>

      <ArtistTestimonialSection>
        <h3>{t('partners.artistTestimonialsTitle')}</h3>
        <ArtistTestimonialItemsColumns>
          <ArtistTestimonialItems>
            <ArtistTestimonialItem>
              <p className="artist-testimonial">
                {t('partners.artist6Testimonial')}
              </p>
              <ArtistTestimonialAuthorArea>
                <img src={dj6} />
                <div className="artist">
                  <p className="artist-author">{t('partners.artist6Author')}</p>
                </div>
              </ArtistTestimonialAuthorArea>
            </ArtistTestimonialItem>

             <ArtistTestimonialItem>
              <p className="artist-testimonial">
                {t('partners.artist5Testimonial')}
              </p>
              <ArtistTestimonialAuthorArea>
                <img src={dj5} />
                <div className="artist">
                  <p className="artist-author">{t('partners.artist5Author')}</p>
                </div>
              </ArtistTestimonialAuthorArea>
            </ArtistTestimonialItem>

            <ArtistTestimonialItem>
              <p className="artist-testimonial">
                {t('partners.artist2Testimonial')}
              </p>
              <ArtistTestimonialAuthorArea>
                <img src={dj2} />
                <div className="artist">
                  <p className="artist-author">{t('partners.artist2Author')}</p>
                </div>
              </ArtistTestimonialAuthorArea>
            </ArtistTestimonialItem>
          </ArtistTestimonialItems>

          <ArtistTestimonialItems>

             <ArtistTestimonialItem>
              <p className="artist-testimonial">
                {t('partners.artist7Testimonial')}
              </p>
              <ArtistTestimonialAuthorArea>
                <img src={dj7} />
                <div className="artist">
                  <p className="artist-author">{t('partners.artist7Author')}</p>
                </div>
              </ArtistTestimonialAuthorArea>
            </ArtistTestimonialItem>

             <ArtistTestimonialItem>
              <p className="artist-testimonial">
                {t('partners.artist8Testimonial')}
              </p>
              <ArtistTestimonialAuthorArea>
                <img src={dj8} />
                <div className="artist">
                  <p className="artist-author">{t('partners.artist8Author')}</p>
                </div>
              </ArtistTestimonialAuthorArea>
            </ArtistTestimonialItem>


            <ArtistTestimonialItem>
              <p className="artist-testimonial">
                {t('partners.artist4Testimonial')}
              </p>
              <ArtistTestimonialAuthorArea>
                <img src={dj4} />
                <div className="artist">
                  <p className="artist-author">{t('partners.artist4Author')}</p>
                </div>
              </ArtistTestimonialAuthorArea>
            </ArtistTestimonialItem>
          </ArtistTestimonialItems>

          <ArtistTestimonialItems>
            <ArtistTestimonialItem>
              <p className="artist-testimonial">
                {t('partners.artist3Testimonial')}
              </p>
              <ArtistTestimonialAuthorArea>
                <img src={dj3} />
                <div className="artist">
                  <p className="artist-author">{t('partners.artist3Author')}</p>
                </div>
              </ArtistTestimonialAuthorArea>
            </ArtistTestimonialItem>
            <ArtistTestimonialItem>
              <p className="artist-testimonial">
                {t('partners.artist1Testimonial')}
              </p>
              <ArtistTestimonialAuthorArea>
                <img src={dj1} />
                <div className="artist">
                  <p className="artist-author">{t('partners.artist1Author')}</p>
                </div>
              </ArtistTestimonialAuthorArea>
            </ArtistTestimonialItem>
          </ArtistTestimonialItems>
        </ArtistTestimonialItemsColumns>
      </ArtistTestimonialSection>
    </ContentsSection>
  );
}

const ContactSection = styled.section`
  position: relative;
  padding: 55px 20px 150px;

  .form-anchor {
    position: absolute;
    top: 10px;
    @media ${config.layout.wide} {
      top: -60px;
    }
  }

  @media ${config.layout.wide} {
    padding: 0 50px 100px;
    min-width: 1200px;

    & > .hash {
      position: relative;
      top: -80px;
    }
  }
`;

const ContactSectionInner = styled.section`
  position: relative;

  @media ${config.layout.wide} {
    max-width: 930px;
    margin: 0 auto;
  }

  h3 {
    font-size: 40px;
    line-height: 43px;
    font-weight: bold;
    text-align: center;

    margin-top: 50px;
    margin-bottom: 50px;
    @media ${config.layout.wide} {
      margin-top: 70px;
      line-height: 56px;
    }
  }

  .form-description {
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    margin-top: 50px;
    margin-bottom: 40px;
  }
`;

const ThanksTitle = styled.h3`
  font-size: 40px;
  line-height: 43px;
  font-weight: bold;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  @media ${config.layout.wide} {
    margin-top: 70px;
    line-height: 56px;
  }
`;

const ThanksDescription = styled.div`
  font-size: 16px;
  line-height: 26px;
  font-weight: bold;
  padding-bottom: 50px;
  @media ${config.layout.wide} {
    margin-bottom: 100px;
  }

  a {
    color: #000;
  }
`;

const SubmitButtonWrap = styled.div`
  @media ${config.layout.wide} {
    width: 350px;
    margin: 0 auto;
  }
`;

const KeepMeLogin = styled.div`
  text-align: center;
  margin: 50px auto;
  max-width: calc(100% - 30px);
  @media ${config.layout.wide} {
    max-width: 100%;
  }

  input {
    display: none;

    &:checked {
      & + label {
        &:before {
        }
      }
    }
  }

  label {
    position: relative;
    font-size: 12px;
    @media ${config.layout.wide} {
      font-size: 14px;
    }
    font-weight: 500;
    margin-left: 7px;
    padding-left: 28px;
    text-align: left;

    &:before {
      position: absolute;
      left: 0;
      top: 0px;
      @media ${config.layout.wide} {
        top: 2px;
      }
    }

    a {
      color: #000;
    }
  }
`;

function ContactSent() {
  const { t } = useTranslation();
  const lang = useLang();

  useEffect(() => {
    const isMobile = window.matchMedia(`${config.layout.mobile}`).matches;
    if (isMobile) {
      setTimeout(() => {
        global.scrollToHash('thanks');
      }, 300);
    } else {
      global.scrollToHash('thanks-pc');
    }
  }, []);

  return (
    <ContactSection data-hash={'thanks'}>
      <div className={'hash'} data-hash={'thanks-pc'} />
      <ContactSectionInner>
        <ThanksTitle>{t('partners.thanksTitle')}</ThanksTitle>
        <ThanksDescription>
          <Trans
            i18nKey="partners.thanksDescription"
            components={[<Link to={withLang(lang, '/contact/')} key="0" />]}
          />
        </ThanksDescription>
      </ContactSectionInner>
    </ContactSection>
  );
}

function ContactUnauth({ setSent }) {
  const { t } = useTranslation();
  const { state } = useLocation();
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState('default');
  const { errorDialogWithAPIError, alertDialog } = useCustomDialog();
  const [agreed, setAgreed] = useState(false);
  const lang = useLang();

  useEffect(() => {
    (async () => {
      const data = await getCountryMaster();
      setCountries(
        data.map((c) => {
          return {
            value: c.country,
            label: c.country_name,
          };
        }),
      );
    })();
  }, []);

  /*
    const categories = [
      'Press',
      'KUVO account (created before Sep 2022)',
      'New venue account',
      'CMO account',
      'Others',
    ].map((v) => {
      return {
        value: v,
        label: v,
      };
    });
  */

  function handleSubmit(event) {
    event.preventDefault();

    if (!agreed) {
      return;
    }

    let formData = new FormData(event.currentTarget);
    let name = (formData.get('name') || '').trim().substr(0, 256);
    let email = (formData.get('email') || '').trim().substr(0, 256);
    let errors = [];
    if (!name) {
      errors.push(t('partners.errors.nameRequired'));
    }
    if (!email) {
      errors.push(t('partners.errors.emailRequired'));
    }
    if (country === 'default') {
      errors.push(t('partners.errors.chooseCountry'));
    }

    if (errors.length) {
      (async function () {
        await alertDialog({
          //buttons: ButtonLayout.None,
          description_element: (
            <div className={'errors'}>
              <ul>
                {errors.map((e, i) => {
                  return <li key={i}>{e}</li>;
                })}
              </ul>
            </div>
          ),
        });
      })();
      return;
    }

    (async () => {
      try {
        await sendVenueInquiry({
          name,
          email,
          country,
        });
        setSent(true);
      } catch (e) {
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();
  }

  const onCountryPullDownChange = (newValue) => {
    console.log(newValue);
    setCountry(newValue);
  };

  return (
    <ContactSection>
      <a name={'form'} className={'form-anchor'} data-hash="form"></a>
      <ContactSectionInner>
        <h3>{t('partners.contactHeading')}</h3>
        <div className={'form-description'}>
          {t('partners.formDescription')}
        </div>
        <form onSubmit={handleSubmit}>
          <RequiredLabel />
          <InputLabel required={true}>{t('partners.country')}</InputLabel>
          <DBDPullDown
            defaultLabel={t('common.selectOne')}
            value={country}
            onChange={onCountryPullDownChange}
            items={countries}
            style={{
              minWidth: '100%',
            }}
          ></DBDPullDown>
          <InputLabel required={true}>{t('partners.venueName')}</InputLabel>
          <FormInput
            type="text"
            required
            name="name"
            maxLength={64}
            onInvalid={(e) => {
              //if (window.scrollY > 140) {
              //  window.scrollTo(0, 140);
              //}
            }}
          />
          <InputLabel required={true}>{t('common.emailAddress')}</InputLabel>
          <FormInput
            type="email"
            required
            name="email"
            maxLength={128}
            onInvalid={(e) => {
              //if (window.scrollY > 140) {
              //  window.scrollTo(0, 140);
              //}
            }}
          />

          <KeepMeLogin>
            <input
              id="keep_me_logged_in"
              name="keep"
              type="checkbox"
              defaultChecked={agreed}
              onChange={(e) => {
                setAgreed(e.target.checked);
              }}
            />
            <label htmlFor="keep_me_logged_in">
              <Trans
                i18nKey="common.privacyPolicyAgreement"
                components={[
                  <a
                    key="0"
                    href={`https://alphatheta.com/${lang || 'en'}/company/privacy-policy/`}
                    target="_blank"
                    rel="noopener"
                  />,
                ]}
              />
            </label>
          </KeepMeLogin>

          <SubmitButtonWrap>
            <button
              type="submit"
              className="dark-button center-fixed"
              style={{
                width: '100%',
              }}
              disabled={!agreed}
            >
              <span>{t('common.submit')}</span>
            </button>
          </SubmitButtonWrap>
        </form>
      </ContactSectionInner>
    </ContactSection>
  );
}

export default function DJMonitorPage() {
  const app = useApp();
  const { t } = useTranslation();
  const [sent, setSent] = useState(false);

  useEffect(() => {
    app.setTitle(t('partners.documentTitle'));

    if (/form/.test(`${window.location.hash || ''}`)) {
      global.scrollToHash('form');
    }
  }, []);

  return (
    <Page>
      <Contents />
      {sent ? <ContactSent /> : <ContactUnauth setSent={setSent} />}
    </Page>
  );
}
